<template>
    <div class="filters__bit">
        <div class="title trigger-collapse trigger-prices">
            <span class="filter-title">Rango de precio</span>
            <img class="icon-dropdown float-right" src="/assets/images/helpers/icon-dropdown.svg" alt="">
        </div>
        <div class="collapse">
            <div class="flex">
                <ul class="list__bit grid__bit p-0 bullet-none mt-0 mb-7">
                    <li v-for="(price, key) in priceRange" :key="'prices-' + price.value" class="item text-left">
                        <input v-model="filters.selected" :value="price.value" class="form-input-checkbox hidden" type="radio"
                        :name="'prices-' + price.value" :id="'prices-' + price.value">
                        <label :for="'prices-' + price.value" class="checkbox-mark">
                            {{ price.name }}
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {Money} from 'v-money';
import { mapState} from 'vuex';

export default {

    data: () => ({
        filters: {
            from: 0,
            to  : 0,
            selected: 0
        },
        numberFormat: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        }
    }),
    computed : {
        ...mapState('catalog',['priceRange'])
    },
    components: {
        Money
    },
    methods: {
        debouncedFiltersUpdate: _.debounce(function(filters) {
            this.$emit('change', 'prices', filters)
        }, 300)
    },
    watch: {
        'filters.selected': {
            handler(newValue){
                this.$store.dispatch("catalog/setPriceFilterSelected", newValue);
                switch (newValue) {
                    case 1:
                        this.filters.from = 1
                        this.filters.to = 450000
                        break;
                    case 2:
                        this.filters.from = 450000
                        this.filters.to = 650000
                        break;
                    case 3:
                        this.filters.from = 650000
                        this.filters.to = 850000
                        break;
                    case 4:
                        this.filters.from = 850000
                        this.filters.to = 90999999
                    default:
                        break;
                }
            }
        },
        'filters': {
            handler(newValue){
                this.debouncedFiltersUpdate(this.filters)
            }, deep: true
        }
    }
}
</script>
